import axios from "axios";
import { API_BASE_URL } from "../config/api";

export const getBackgroundImages = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/background-images`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching background images:", error);
    throw new Error(
      "Failed to fetch background images: " +
        (error.response?.data?.error || error.message)
    );
  }
};

export const uploadBackgroundImage = async (imageFile, name) => {
  const formData = new FormData();
  formData.append("image", imageFile);
  formData.append("name", name);

  try {
    const response = await axios.post(
      `${API_BASE_URL}/background-images`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      }
    );
    return response.data.background;
  } catch (error) {
    console.error("Error uploading background image:", error);
    const errorMsg = error.response?.data?.error || "Unknown upload error";
    throw new Error(errorMsg);
  }
};